import {
  Component,
  OnInit,
  ViewChild,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { getArea, getLength } from 'ol/sphere';
// import {LineString, Point} from 'ol/geom';
import { Draw } from 'ol/interaction';
import { Vector as VectorSource } from 'ol/source';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import { LineString, Point, Polygon } from 'ol/geom';
import { Vector as VectorLayer } from 'ol/layer';
import { Circle, Fill, Icon, Stroke, Style } from 'ol/style';
// import Circle from 'ol/style/Circle';
import { HttpClient } from '@angular/common/http';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
import {toStringHDMS} from 'ol/coordinate';
import * as utm from 'utm';
// declare let utm: any;
@Component({
  selector: 'app-metricx',
  templateUrl: './metricx.component.html',
  styleUrls: ['./metricx.component.css'],
})
export class MetricxComponent implements OnInit, OnDestroy {
  panelOpenState = false;
  panelOpenState1 = false;
  panelOpenState2 = false;
  toolData: any;
  baseMaps: any;
  boundaries: any;
  metricsData: any;
  matricsType: any;
  lastPoint: any;
  //point
  lati: any;
  lon: any;
  //for conversion
  feet: any;
  feetToMeter: any;
  feetToKilometer: any;
  feetToMiles: any;
  meterSqaureToFeetSqaure: any;
  meterSqaureToMilesSqaure: any;
  meterSqaureToAcres: any;
  // conversion end
  vectorDrawSource: any;
  coordinatesPosition: any
  draw: any;
  modify: any;
  modifyStyle: any;
  area: any;
  outputArea: any;
  outputLength: any;
  rmInteraction: any;
  dblClickInteraction: any;
  latlon: any;
  type: any;
  listener: any;
  sketch: any;
  html: any;
  mapId: any;
  logEvent: any;
  eventName: any;
  previousId: any;
  state: any;
  layersId: any;
  legendToolName: any;
  unitTesting: any;
  closeMetrics = false;
  enableText = false;
  myOptions1: any = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class3',
  };

  //DMS
  lonDMS: any
  latDMS: any
  lonDMSV: any
  latDMSV: any
  umtZone: any
  // UTM
  utmEasting: any
  utmNorthing: any
  utmZone: any
  hem: any
  zoneArea: any
  @ViewChild('panel') panel: any;
  @ViewChild('panel1') panel1: any;
  @ViewChild('panel2') panel2: any;
  constructor(
    public sideNavService: SideNavService,
    public mapService: MapServiceService,
    private http: HttpClient
  ) {
    // this.sideNavService.clickedMetrics('point');
    this.state = this.sideNavService.metricsState;
    this.metricsData =
      this.mapService.accessMapApi.map_data.map_data.tools_tips;
    if (
      this.mapService.accessMapApi.map_data.map_data.tool_desc.metrics == null
    ) {
      this.html = '';
    } else {
      this.html =
        this.mapService.accessMapApi.map_data.map_data.tool_desc.metrics;
    }
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.metricsData =
      this.mapService.accessMapApi.map_data.map_data.tools_tips;
    this.state = this.sideNavService.metricsState;
  }

  ngOnInit(): void {
    this.layersId = this.mapService.getLayersId().toString();
    this.vectorDrawSource = new VectorSource();
    this.mapService.DrawLayer = new VectorLayer({
      source: this.vectorDrawSource,
    });
    this.mapService.mapLayer.addLayer(this.mapService.DrawLayer);
  }
  expanded(value: any, id: any) {
    if (!this.mapService.toolNameForMetrics) {

      this.getDistance(value, id);
    }
  }

  // number into 6 digit
  roundNumber(num: any, dec: any) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
  }

  // on click get type
  getDistance(drawType: string, id: any): void {
    this.reset();
    //dropdown handling
    if (id == this.previousId) {
      switch (id) {
        case 1:
          this.panelOpenState = true;
          this.panel?.open();
          break;
        case 2:
          this.panelOpenState1 = true;
          this.panel1?.open();
          break;
        case 3:
          this.panelOpenState2 = true;
          this.panel2?.open();
          break;
        default:
          break;
      }
    } else {
      switch (id) {
        case 1:
          this.panelOpenState1 = false;
          this.panel1?.close();
          this.panelOpenState2 = false;
          this.panel2?.close();
          this.panelOpenState = true;
          this.panel?.open();
          break;
        case 2:
          this.panelOpenState2 = false;
          this.panel2?.close();
          this.panelOpenState = false;
          this.panel?.close();
          this.panelOpenState1 = true;
          this.panel1?.open();
          break;
        case 3:
          this.panelOpenState = false;
          this.panel?.close();
          this.panelOpenState1 = false;
          this.panel1?.close();
          this.panelOpenState2 = true;
          this.panel2?.open();
          break;
        default:
          break;
      }
    }
    this.setState();
    this.previousId = id;
    this.type = drawType;
    // find DoubleClickZoom interaction
    this.mapService.mapLayer
      .getInteractions()
      .getArray()
      .forEach((interaction: any) => {
        if (interaction instanceof DoubleClickZoom) {
          this.dblClickInteraction = interaction;
        }
      });
    // remove from map
    this.mapService.mapLayer.removeInteraction(this.dblClickInteraction);
    this.mapService.removeInteraction =
      this.mapService.mapLayer.removeInteraction(this.draw);
    // this.mapService.DrawLayer.getSource().clear();
    if (this.type) {
      this.mapService.getdrawEnable(true);
    }
    this.addInteraction();
  }

  enableTextFiled() {
    this.enableText = !this.enableText
  }

  addInteraction() {
    // formatLength for line
    const formatLength = (line: any) => {
      const length = getLength(line);
      this.feet = length * 3.2808;
      return this.feet;
    };
    // formatArea for polygon
    const formatArea = (polygon: any) => {
      this.area = getArea(polygon);
      return this.area;
    };
    const layer = this.mapService.DrawLayer;
    //set index to show above then boundaries
    this.mapService.DrawLayer.setZIndex(101);
    this.draw = new Draw({
      source: layer.getSource(),
      type: this.type,
      //blue point custom style
      style: new Style({
        image: new Circle({
          radius: 6,
          fill: new Fill({
            color: 'rgb(238, 153, 0 , 0.3)',
          }),
          stroke: new Stroke({
            color: 'rgb(238, 153, 0)',
            width: 2,
          }),
        }),
      }),
    });
    this.rmInteraction = this.draw;
    this.mapService.mapLayer.addInteraction(this.draw);
    this.draw.on('drawstart', (evt: any) => {
      this.sketch = evt.feature;
      const polystyle = new Style({
        fill: new Fill({
          color: 'rgb(238, 153, 0 , 0.3)',
        }),
        stroke: new Stroke({
          color: 'rgb(238, 153, 0)',
          width: 2,
        }),
      });
      this.sketch.setStyle(polystyle);
      this.mapService.DrawLayer.getSource().addFeatures([this.sketch]);
      this.listener = this.sketch.getGeometry().on('change', (evt: any) => {
        const geom = evt.target;

        if (geom instanceof Polygon) {
          this.outputArea = formatArea(geom);
          this.feet = this.outputArea * 10.7639;
          this.feet = this.feet.toFixed(0);

          this.feetToMeter = this.outputArea.toFixed(0);

          this.feetToKilometer = this.outputArea * 1e-6;
          this.feetToKilometer = this.feetToKilometer.toFixed(2);

          this.feetToMiles = this.outputArea * 3.86102e-7;
          this.feetToMiles = this.feetToMiles.toFixed(2);

          this.meterSqaureToFeetSqaure = this.outputArea * 1076391042;
          this.meterSqaureToFeetSqaure =
            this.meterSqaureToFeetSqaure.toFixed(2);

          this.meterSqaureToMilesSqaure = this.outputArea * 1e-4;
          this.meterSqaureToMilesSqaure =
            this.meterSqaureToMilesSqaure.toFixed(2);

          this.meterSqaureToAcres = this.outputArea * 0.000247105;
          this.meterSqaureToAcres = this.meterSqaureToAcres.toFixed(2);
        } else if (geom instanceof LineString) {
          this.outputLength = formatLength(geom);
          this.feet = this.outputLength;
          this.feet = this.feet.toFixed(0);

          this.feetToMeter = this.feet * 0.3048;
          this.feetToMeter = this.feetToMeter.toFixed(0);

          this.feetToKilometer = this.feet * 0.0003048;
          this.feetToKilometer = this.feetToKilometer.toFixed(2);

          this.feetToMiles = this.feet * 0.000189393939;
          this.feetToMiles = this.feetToMiles.toFixed(2);
        }
      });
    });
    this.draw.on('drawend', (evt: any) => {
      this.mapService.DrawLayer.getSource().clear();
      const geom = evt.feature.getGeometry();
      //after drawn polygon
      if (geom instanceof Polygon) {
        const polystyle1 = new Style({
          fill: new Fill({
            color: 'rgb(204, 229, 236 , 0.3)',
          }),
          stroke: new Stroke({
            color: 'rgb(238, 153, 0)',
            width: 2,
          }),
        });
        evt.feature.setStyle(polystyle1);
      }

      if (geom instanceof Point) {
        const point = evt.feature.clone();
        const merter = evt.feature
          .getGeometry()
          .transform('EPSG:3857', 'EPSG:4326');
        this.lati = '';
        this.lon = '';
        const style = new Style({
          image: new Icon({
            imgSize: [32, 68],
            src: '/assets/img/measurepoint.png',
            offset: [-5, 0],
            scale: 1,
          }),
        });
        point.setStyle(style);
        this.vectorDrawSource.addFeature(point);
        this.vectorDrawSource.changed();
        const tooltipCoord = merter.getCoordinates();
        // this.findLocation(tooltipCoord)
        this.lati = this.roundNumber(tooltipCoord[1], 6);
        this.lon = this.roundNumber(tooltipCoord[0], 6);
        if (this.lon < -180 || this.lon > 180) {
          this.lon = this.roundNumber(((this.lon + 540) % 360) - 180, 6);
        }
        // UTM
        const data1:any = this.latLonToUtm(tooltipCoord[1], this.lon);
        this.utmEasting = this.roundNumber(data1.easting, 0)
        this.utmNorthing = this.roundNumber(data1.northing, 0)
        this.utmZone = data1.zoneNum + data1.zoneLetter
         // DMS
        const data = toStringHDMS(tooltipCoord)
        const latLngArr = data.split(" ");
        const latLngStrArr = [`${latLngArr[0]} ${latLngArr[1]} ${latLngArr[2]} ${latLngArr[3]}`, `${latLngArr[4]} ${latLngArr[5]} ${latLngArr[6]} ${latLngArr[7]}`];
        this.latDMSV = latLngStrArr[0]
        this.lonDMSV = latLngStrArr[1]

      }
      this.activityLoging(this.type);
    });
    //for unit testing automation drawing
    if (this.unitTesting) {
      if (this.type == 'Point') {
        this.draw.appendCoordinates([[-13575305.356131407, 4533670.459717148]]);
        this.draw.finishDrawing();
      }
      if (this.type == 'LineString') {
        this.draw.appendCoordinates([
          [-13549392.828542732, 4547734.79292162],
          [-13522792.74269949, 4535963.490565703],
        ]);
        this.draw.finishDrawing();
      }
      if (this.type == 'Polygon') {
        this.draw.appendCoordinates([
          [36.301744, 50.010456],
          [36.30218, 50.019864],
          [36.301025, 50.02173],
          [36.293856, 50.016215],
          [36.293682, 50.00924],
          [36.301744, 50.010456],
        ]);
        this.draw.finishDrawing();
      }
    }
  }


  latLonToUtm(latitude: number, longitude: number) {
    const ff = utm.fromLatLon(latitude, longitude);
    return ff;
  }

  // Copy values
  copyToClipboard(td: any) {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = td;
    dummy.select();
    document.execCommand('copy');
    // document.body.removeChild(dummy);
  }
  reset(): void {
    const features = this.mapService.DrawLayer.getSource().getFeatures();
    features.forEach((feature: any) => {
      this.mapService.DrawLayer.getSource().removeFeature(feature);
      this.sketch = null;
    });
    if (this.mapService.DrawLayer) {
      this.mapService.DrawLayer.getSource().clear();
    }
    this.feet = 0;
    this.feetToMeter = 0;
    this.feetToKilometer = 0;
    this.feetToMiles = 0;
    this.meterSqaureToFeetSqaure = 0;
    this.meterSqaureToMilesSqaure = 0;
    this.meterSqaureToAcres = 0;
    this.lati = 0;
    this.lon = 0;
    this.closeMetrics = false;
  }

  setState(): void {
    this.sideNavService.metricsState = {
      expandPanel1: this.panelOpenState,
      expandPanel2: this.panelOpenState1,
      expandPanel3: this.panelOpenState2,
    };
    this.state = this.sideNavService.metricsState;
    // console.log(this.state)
  }
  closeLeftPanel() {
    this.mapService.DrawLayer && this.mapService.DrawLayer.getSource().clear();
    this.mapService.mapLayer.removeInteraction(this.draw);
    this.mapService.getdrawEnable(false);
    this.mapService.setClosePanel(true);
    this.mapService.closePanel = true
    this.closeMetrics = false;
  }

  activityLoging(type: any
  ) {
    switch (type) {
      case 'Polygon':
        type = 'Area'
        break;
      case 'LineString':
        type = 'Distance'
        break;
      case 'Point':
        type = 'Position'
        break;
      default:
        break;
    }
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapService.mapId.toString(),
          event: "Click",
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: `Metrics:${type}:Activate`,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(() => {
          // console.log('a');
        }, (error: any) => {
          if (error.status == 403) {
            location.reload();
          }
        });
      })
  }
  @HostListener('unloaded')
  ngOnDestroy() {
    this.mapService.DrawLayer && this.mapService.DrawLayer.getSource().clear();
    this.mapService.mapLayer.removeInteraction(this.draw);
    this.mapService.getdrawEnable(false);
  }
}
